import {useMemo} from 'react';
import {SVG} from '../../../../../constants/assetLists';
import AppTooltip from '../../../../../components/common/AppTooltip';

type Props = {
  form: {
    _id: string;
    title: string;
  };
};

function FormBox({form}: Props) {
  const currentUser = useMemo(() => {
    const stored = localStorage.getItem('user');
    return stored ? JSON.parse(stored) : null;
  }, []);

  const handleClick = () => {
    const params = new URLSearchParams();
    if (currentUser?._id) params.set('userId', currentUser._id);
    if (currentUser?.email) params.set('email', currentUser.email);
    if (currentUser?.firstName) params.set('firstName', currentUser.firstName);
    if (currentUser?.lastName) params.set('lastName', currentUser.lastName);
    const url = `${window.location.origin}/form/${form._id}?${params.toString()}`;
    window.open(url, '_blank');
  };

  return (
    <button
      className="flex items-center gap-2 bg-gray80 px-[5px] py-[3px] rounded-[8px]"
      onClick={handleClick}>
      <div className="w-[18px] h-[18px]">
        <img
          src={SVG.linkBlackIcon}
          alt="form link"
          className="w-full h-full object-contain"
        />
      </div>
      <AppTooltip title={form.title?.length > 30 ? form.title : ''}>
        <span className="underline whitespace-nowrap text-darkBlue cursor-pointer">
          {form.title?.length > 30
            ? form.title.slice(0, 30) + '...'
            : form.title}
        </span>
      </AppTooltip>
    </button>
  );
}

export default FormBox;
